module.exports = __webpack_public_path__ + "static/img/news-20230620.3e12238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20230620.png
// module id = znu3
// module chunks = 0